<script>
import LucideIcon from '../../../../components/LucideIcon.vue';
import EmptyState from '../../../../components/widgets/EmptyState.vue';

export default {
  components: {
    EmptyState,
    LucideIcon,
  },
};
</script>

<template>
  <div
    class="h-full p-6 w-full flex-shrink-0 flex-grow-0"
  >
    <EmptyState
      :title="$t('TEAMS_SETTINGS.FINISH.TITLE')"
      :message="$t('TEAMS_SETTINGS.FINISH.MESSAGE')"
      :button-text="$t('TEAMS_SETTINGS.FINISH.BUTTON_TEXT')"
    >
      <template #icon>
        <LucideIcon name="circle-check-big" size="48" class="text-grass-500"/>
      </template>
      <div class="w-full text-center">
        <router-link
          class="button rounded-lg !bg-n-bluegray-4 dark:!bg-n-bluegray-4 !text-white dark:!text-white"
          :to="{
            name: 'settings_teams_list',
          }"
        >
          {{ $t('TEAMS_SETTINGS.FINISH.BUTTON_TEXT') }}
        </router-link>
      </div>
    </EmptyState>
  </div>
</template>
